<template>
    <div>
        <form class="flex-row" @submit.prevent="onSubmit">
            <label for="newsletter" hidden>{{ label }}</label>
            <input id="newsletter" name="newsletter" type="mail"
                   :class="{ error: hasError || hasErrorFormat || confirmError }"
                   :placeholder="label" v-model="email" />
            <input type="submit" value="OK" />
        </form>
        <p v-if="hasError || hasErrorFormat || confirmError" class="error">
            <slot v-if="hasError" name="error-no-email"></slot>
            <slot v-if="hasErrorFormat" name="error-format-email"></slot>
            <template v-if="confirmError">{{ confirmError }}</template>
        </p>
        <p v-if="confirmMsg" class="confirm">
            {{ confirmMsg }}
        </p>
    </div>
</template>

<script>
import Vue from "vue";
import axios from 'axios';
import SearchResults from "../../popups/SearchResults";

export default {
    props: ['label'],
    data() {
        return {
            email: null,
            hasError: false,
            hasErrorFormat: false,
            confirmMsg: null,
            confirmError: null
        }
    },
    watch: {

    },
    mounted() {

    },
    methods: {
        resetErrors() {
            this.hasError = this.hasErrorFormat = false;
            this.confirmMsg = this.confirmError = null;
        },
        onSubmit() {
            this.resetErrors();

            if(!this.email) {
                this.hasError = true;
                return;
            }

            if(!this.validateEmail(this.email)) {
                this.hasErrorFormat = true;
                return;
            }

            axios({
                method: 'post',
                url: window.drupalSettings.path.baseUrl + 'api/v1/newsletter',
                data: {
                    email: this.email
                }
            }).then((response) => {
                this.confirmMsg = response.data.confirmMsg;
            }).catch((error) => {
                this.confirmError = error.response.data.errors;
            });
        },
        validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }
}
</script>
